const Notice = {
	show: function(args) {
		if (!'message' in args) {
			// Message must be set and mustn't be empty.
			return;
		}

		let icon_class = '';

		switch (args.type) {
			case 'success':
				icon_class = 'check-tick';
				break;

			case 'error':
			case 'warning':
				icon_class = 'warning-alert';
				break;

			case 'info':
			default:
				icon_class = 'info';
				break;
		}

		const options = {
			icon: icon_class,
			type: args.type
		};

		if (args.dismissible) {
			options.dismiss = {show: true};
		}

		if (args.autoclose) {
			options.autoclose = {timeout: args.autoclose};
		} else {
			options.autoclose = {show: false};
		}

		const $suiHeader    = document.querySelector('.sui-header');
		const noticeId     = 'shipper-notice-' + Math.random().toString(36).substr(2,9);
		let $noticesWrapper = document.querySelector('.sui-floating-notices');
		let $notice         = document.createElement('div');

		if (!$noticesWrapper) {
			$noticesWrapper = document.createElement('div');
			$noticesWrapper.setAttribute('class', 'sui-floating-notices');
		}
		$suiHeader.insertBefore($noticesWrapper, $suiHeader.childNodes[0]);

		$notice.setAttribute('id', noticeId);
		$notice.setAttribute('role', 'alert');
		$notice.setAttribute('aria-live', 'assertive');
		$notice.setAttribute('class', 'sui-notice');

		$noticesWrapper.appendChild($notice);

		const noticeContent = `<p>${args.message}</p>`;
		window.SUI.openNotice(noticeId, noticeContent, options);
	},
};

;(function( $ ) {

	function handle( callback ) {
		return function( e ) {
			if ( e && e.preventDefault ) e.preventDefault();
			if ( e && e.stopPropagation ) e.stopPropagation();

			callback();

			return false;
		}
	}

	function open_modal( id, replace_modal ) {
		var replace_modal = replace_modal ? true : false;
		var modal_id = get_modal_id(id);
		var focus_after_closed = this;
		var focus_when_open = undefined;
		var has_overlay_mask = false;
		var modal = get_modal(id);

		SUI[ replace_modal ? 'replaceModal' : 'openModal' ]( modal_id, focus_after_closed, focus_when_open, has_overlay_mask )

		return modal;
	}

	function get_modal_id( id ) {
		return 'shipper-site_selection-' + id;
	}

	function get_modal( id ) {
		return $( '#' + get_modal_id( id ) );
	}

	function send_request( act ) {
		var selection = get_modal( 'destination' ).find( '[name="site"] :selected' ),
			promise = $.post(
				ajaxurl,
				{
					action: act,
					_wpnonce: get_modal( 'destination' ).find( ':hidden[name="_wpnonce"]' ).val(),
					site: selection.val(),
					domain: selection.text()
				},
				function () {}
			);
		promise.fail( show_install_fail )
		return promise;
	}

	function activate_prepare_step( step ) {
		var $modal = get_modal( 'prepare' ),
			$steps = $modal.find( '.shipper-progress-steps [data-step]' ),
			$target = $steps.filter( '[data-step="' + step + '"]' ),
			$previous = $target.prevAll( '[data-step]' ),
			progress = parseInt( ( ( $previous.length + 1 ) / $steps.length ) * 100, 10 );

		$steps
			.filter( '.shipper-step-active' )
				.removeClass( 'shipper-step-active' )
				.find( 'i' ).remove();
		$target
			.addClass( 'shipper-step-active' )
			.append( '<i class="sui-icon-loader sui-loading"></i>' );

		$modal
			.find( '.sui-progress-text' )
				.text( progress + '%' )
			.end()
			.find( '.sui-progress-bar span' )
				.width( progress + '%' )
			.end()
		;
	}

	function show_site_prepare() {
		var destination = get_modal( 'destination' ).find( '[name="site"]' ).val();
		set_site_urls_in_modal( 'prepare' );
		open_modal( 'prepare' );

		activate_prepare_step( 'install' );
		send_request( 'shipper_install_activate' )
			.done( function ( resp ) {
				activate_prepare_step( 'activate' );
				setTimeout( function() {
					activate_prepare_step( 'add-to-api' );
					send_request( 'shipper_add_to_api' )
						.done( function( resp ) {
							if ( !! ( resp || {} ).success ) {
								move_to_preflight( destination );
							} else {
								show_install_fail();
							}
						} )
					;
				}, 1000 );
			} )
		;
	}

	function set_site_urls_in_modal( modal, domain ) {
		var dmn = domain || get_modal( 'destination' ).find( '[name="site"] :selected' ).text(),
			$modal = get_modal( modal ),
			$targets = $modal.find( '.shipper-site-domain' );
		$targets.text( dmn );
	}

	function show_install_fail() {
		set_site_urls_in_modal( 'install-fail' );
		open_modal( 'install-fail' );
	}

	function move_to_preflight( site_id ) {
		window.location.search += '&site=' + site_id;
		return false;
	}

	function prepare_selected_site() {
		var destination = get_modal( 'destination' ).find( '[name="site"]' ).val(),
			$button = get_modal( 'destination' ).find( 'button[type="submit"]' ),
			button = $button.html();
		if ( ! destination ) {
			return false;
		}
		$button
			.addClass( 'sui-button-onload' )
			.html(
				'<i class="sui-icon-loader sui-loading" aria-hidden="true"></i>'
			);
		send_request( 'shipper_is_shippable' )
			.done( function ( resp ) {
				var status = ( resp || {} ).success;
				if ( status ) {
					return move_to_preflight( destination );
				} else {
					return show_site_prepare();
				}
			} )
			.always( function () {
				$button.html( button ).removeClass( 'sui-button-onload' );
			} )
		;
	}

	function show_hub_sites( resp ) {
		var replace_modal = true;
		open_modal( 'destination', replace_modal );

		var $target = get_modal( 'destination' ).find( '.shipper-selection.select-name' ),
			success = !! ( resp || {} ).success,
			sites = ( resp || {} ).data || [],
			content = '';

		if ( success ) {
			$.each( sites, function( idx, site ) {
				content += '<option value="' + idx + '">' + site + '</option>';
			} );
			$target.html(
				'<select name="site" class="sui-select">' + content + '</select>'
			);
			get_modal( 'destination' )
				.find( '[href="#refresh-locations"]' )
					.off( 'click' )
					.on( 'click', handle( load_hub_sites ) )
					.end()
				.find( 'button[type="submit"]' )
					.off( 'click' )
					.on( 'click', handle( prepare_selected_site ) )
					.end()
				.find( 'select[name="site"]' ).SUIselect2({
					dropdownCssClass: 'sui-select-dropdown',
					dropdownParent: get_modal( 'destination' )
				})
			;
		} else {
			open_modal( 'loading-error', replace_modal );
		}
	}

	function load_hub_sites( newModal ) {
		var replace_modal = ! newModal;
		open_modal( 'loading', replace_modal );
		$.post( ajaxurl, {
			action: 'shipper_list_hub_sites',
			_wpnonce: get_modal( 'loading' ).find( '[name="_wpnonce"]' ).val()
		} )
			.done( function( data ) {
				show_hub_sites( data );
			} )
			.error( function() {
				show_hub_sites();
			} );
	}

	/**
	 * Toggle the password display button.
	 *
	 * @param {*} modal
	 * @returns
	 */
	function onPasswordModalDisplay(modal) {
		var password_eye = modal.find( '.shipper-password-eye' );

		modal.find( '#shipper-wpmu-dev-password' ).on( "focus", function () {
			password_eye.show();
		});

		password_eye.off( 'click' ).on( 'click', toggle_shipper_password_eye );

		if ( maybe_confirm_password( modal ) ) {
			return;
		}

		modal.find( '.shipper-confirm-password' )
			.off( 'click' )
			.on( 'click', get_auth_key );
		modal.find( '.shipper-cancel' )
			.off( 'click' )
			.on( 'click', move_to_main_page )
	}

	function confirm_password() {
		// If member comes with back button.
		if ( sessionStorage.getItem( 'shipper_hub_password_confirmed' ) ) {
			load_hub_sites( true );
			return;
		}

		var href = window.location.href;
		var modal = null;
		if ( href.indexOf( 'referer=google_login' ) >= 0 ) {
			if ( href.indexOf( 'api_error=auth' ) >= 0 ) {
				Notice.show({
					message: _shipper.i18n.google_auth_failed,
					type: 'error',
					dismissible: false,
					autoclose: 3000
				});

				window.history.pushState({}, '', href.replace('&referer=google_login&api_error=auth', '' ) );
				setTimeout(() => {
					modal = open_modal( 'confirm-password' );
					onPasswordModalDisplay(modal);
				}, 4000);
			} else if (href.indexOf( 'set_apikey' ) ) {
				modal = open_modal( 'confirm-password' );
				onPasswordModalDisplay(modal);
				window.history.pushState({}, '', href.substring(0, href.indexOf('&referer') ) );
			}
		} else {
			const el = document.querySelector('#shipper-site_selection-confirm-password');

			if (!el) {
				return;
			}

			if (el) {
				modal = open_modal( 'confirm-password' );
				onPasswordModalDisplay(modal);
			}
		}
	}

	function toggle_shipper_password_eye( e ) {
		e.preventDefault();

		var eye_button = $(this);
		var password_field = eye_button.siblings( '#shipper-wpmu-dev-password' );

		if ( password_field.attr( 'type') === 'password' ) {
			password_field.attr( 'type', 'text' );
		} else {
			password_field.attr( 'type', 'password' );
		}

		eye_button.find( 'i' ).toggleClass( 'sui-icon-eye-hide' );
	}

	function move_to_main_page() {
		window.location.search = 'page=shipper-api';
	}

	function maybe_confirm_password( modal ) {
		// if it's not the page we'are looking for, return
		if ( ! window.location.search.includes('page=shipper-api') ) {
			return;
		}

		if ( ! window.location.search.includes( 'set_apikey' ) && ! window.location.search.includes( 'api_error' ) ) {
			return;
		}

		if ( ! window.location.search.includes( 'api_error' ) ) {
			// time to show the connecting to wpmudev modal.
			open_modal( 'connecting-wpmudev', true );
		}

		var data = {
			action: 'shipper_confirm_wpmudev_password',
			auth_key: modal.find( '.shipper-confirm-password' ).data( 'authKey' ),
			_wpnonce: modal.find( '.shipper-confirm-password' ).data( 'confirmPassword' ),
		};

		var position = window.location.href.indexOf( '&set_apikey' );

		if ( window.history.pushState && position !== -1 ) {
			history.pushState({}, null, window.location.href.substring( 0, position ) );
		}

		$.post( ajaxurl, data )
			.done( function( response ) {
				if ( response && response.success ) {
					sessionStorage.setItem( 'shipper_hub_password_confirmed', 'true' );
					return load_hub_sites();
				}

				var referer  = window.location.href.indexOf( 'referer' );
				var apiError = window.location.href.indexOf( 'api_error' );

				if ( apiError >= 0 ) {
					if ( referer < 0 ) {
						modal.find( '#shipper-wpmu-dev-password' ).css( 'border-bottom', '2px solid #FF6D6D' );
						modal.find( '#shipper-wpmu-dev-password-error' ).show();
					}
				}
			} )
			.error( function() {
				modal.find( '#shipper-wpmu-dev-password-something-went-wrong' ).show();
			})
			.always( function() {
				modal.find( '.shipper-confirm-password' ).removeClass( 'sui-button-onload' );
			})

		return false;
	}

	function get_auth_key( e ) {
		var modal = get_modal( 'confirm-password' );
		modal.find( '.shipper-confirm-password' ).addClass( 'sui-button-onload' );
	}

	function init() {
		if ( ! $( '.sui-box.shipper-select-site' ).length ) {
			return false;
		}
		setTimeout( confirm_password );
	}
	$( init );

})( jQuery );
